/** Справочник периода для диагностики маркетинга (Часть 1 → Часть 2). */

export const DEFAULT_DIAGNOSTIC_PERIOD_ID = '1';

export const DIAGNOSTIC_PERIOD_DIRECTORY = {
  1: { id: '1', months: 1, label: 'за месяц', order: 1 },
  3: { id: '3', months: 3, label: 'за 3 месяца', order: 2 },
  6: { id: '6', months: 6, label: 'за 6 месяцев', order: 3 },
  12: { id: '12', months: 12, label: 'за 12 месяцев', order: 4 },
};

export const DIAGNOSTIC_PERIOD_LIST = Object.values(DIAGNOSTIC_PERIOD_DIRECTORY).sort(
  (a, b) => a.order - b.order,
);

export const getDiagnosticPeriod = (periodId) =>
  DIAGNOSTIC_PERIOD_DIRECTORY[periodId] || DIAGNOSTIC_PERIOD_DIRECTORY[DEFAULT_DIAGNOSTIC_PERIOD_ID];

/** Условные дни в периоде (30 дн. × месяцы) — для «продаж в день». */
export const getDiagnosticPeriodDays = (periodId) => getDiagnosticPeriod(periodId).months * 30;
